var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Auth } from '@aws-amplify/auth';
import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import * as actions from '../constants/actionTypes';
import callApi from '../graphql/callApi';
import * as selectors from '../selectors/environment';
import StandingStore from '../standingStore';
import sagaFactory from '../utils/sagaFactory';
export function login(_a) {
    var username, password, metadata, res, action, error_1, message;
    var payload = _a.payload, next = _a.next;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 6, , 8]);
                username = payload.username, password = payload.password, metadata = payload.metadata;
                return [4 /*yield*/, Auth.signIn(username, password, metadata)];
            case 1:
                res = _b.sent();
                return [4 /*yield*/, put({
                        type: actions.login.type.SUCCESS,
                        payload: res,
                    })];
            case 2:
                _b.sent();
                StandingStore.setItem('accessToken', res.signInUserSession.accessToken.jwtToken);
                StandingStore.setItem('idToken', res.signInUserSession.idToken.jwtToken);
                StandingStore.setItem('refreshToken', res.signInUserSession.refreshToken.token);
                return [4 /*yield*/, callApi.createPrivateLink()];
            case 3:
                _b.sent();
                return [4 /*yield*/, put({
                        type: actions.getUser.type.REQUEST,
                    })];
            case 4:
                _b.sent();
                return [4 /*yield*/, take([
                        actions.getUser.type.SUCCESS,
                        actions.getUser.type.FAILED,
                    ])];
            case 5:
                action = _b.sent();
                if (action.type === actions.getUser.type.FAILED) {
                    throw new Error('Get user fail');
                }
                next(true);
                return [3 /*break*/, 8];
            case 6:
                error_1 = _b.sent();
                console.error('login', error_1);
                message = error_1.message;
                next(false, message);
                return [4 /*yield*/, put({
                        type: actions.login.type.FAILED,
                    })];
            case 7:
                _b.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
export function signUp(_a) {
    var username, password, resSignUp, resSignIn, action, error_2, message;
    var payload = _a.payload, next = _a.next;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 8, , 10]);
                username = payload.username, password = payload.password;
                return [4 /*yield*/, Auth.signUp({ username: username, password: password })];
            case 1:
                resSignUp = _b.sent();
                return [4 /*yield*/, put({
                        type: actions.signUp.type.SUCCESS,
                        payload: resSignUp,
                    })];
            case 2:
                _b.sent();
                return [4 /*yield*/, Auth.signIn(username, password)];
            case 3:
                resSignIn = _b.sent();
                return [4 /*yield*/, put({
                        type: actions.login.type.SUCCESS,
                        payload: resSignIn,
                    })];
            case 4:
                _b.sent();
                StandingStore.setItem('accessToken', resSignIn.signInUserSession.accessToken.jwtToken);
                StandingStore.setItem('idToken', resSignIn.signInUserSession.idToken.jwtToken);
                StandingStore.setItem('refreshToken', resSignIn.signInUserSession.refreshToken.token);
                return [4 /*yield*/, call(callApi.createPrivateLink)];
            case 5:
                _b.sent();
                return [4 /*yield*/, put({
                        type: actions.getUser.type.REQUEST,
                    })];
            case 6:
                _b.sent();
                return [4 /*yield*/, take([
                        actions.getUser.type.SUCCESS,
                        actions.getUser.type.FAILED,
                    ])];
            case 7:
                action = _b.sent();
                if (action.type === actions.getUser.type.FAILED) {
                    throw new Error('Get user fail');
                }
                next(true);
                return [3 /*break*/, 10];
            case 8:
                error_2 = _b.sent();
                message = error_2.message;
                console.error('signUp', error_2);
                next(false, message);
                return [4 /*yield*/, put({
                        type: actions.signUp.type.FAILED,
                    })];
            case 9:
                _b.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
export function refresh(_a) {
    var user, action, err_1, message;
    var _b = _a.payload, payload = _b === void 0 ? {} : _b, next = _a.next;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 10, , 12]);
                return [4 /*yield*/, Auth.currentAuthenticatedUser()];
            case 1:
                user = _c.sent();
                if (!user.signInUserSession.accessToken.jwtToken) return [3 /*break*/, 8];
                StandingStore.setItem('accessToken', user.signInUserSession.accessToken.jwtToken);
                StandingStore.setItem('idToken', user.signInUserSession.idToken.jwtToken);
                StandingStore.setItem('refreshToken', user.signInUserSession.refreshToken.token);
                return [4 /*yield*/, callApi.createPrivateLink()];
            case 2:
                _c.sent();
                if (!payload.isJustTokenUpdate) return [3 /*break*/, 4];
                return [4 /*yield*/, put({
                        type: actions.refresh.type.SUCCESS,
                        payload: user,
                    })];
            case 3:
                _c.sent();
                next === null || next === void 0 ? void 0 : next(true);
                return [2 /*return*/];
            case 4: return [4 /*yield*/, put({
                    type: actions.getUser.type.REQUEST,
                })];
            case 5:
                _c.sent();
                return [4 /*yield*/, take([
                        actions.getUser.type.SUCCESS,
                        actions.getUser.type.FAILED,
                    ])];
            case 6:
                action = _c.sent();
                if (action.type === actions.getUser.type.FAILED) {
                    throw new Error('Get user fail');
                }
                return [4 /*yield*/, put({
                        type: actions.refresh.type.SUCCESS,
                        payload: user,
                    })];
            case 7:
                _c.sent();
                if (next) {
                    next(true);
                }
                return [3 /*break*/, 9];
            case 8: throw new Error('Refresh fail');
            case 9: return [3 /*break*/, 12];
            case 10:
                err_1 = _c.sent();
                console.error('refresh', err_1);
                StandingStore.removeItem('accessToken');
                StandingStore.removeItem('idToken');
                StandingStore.removeItem('refreshToken');
                if (next) {
                    message = err_1.message;
                    next(false, message);
                }
                return [4 /*yield*/, put({
                        type: actions.refresh.type.FAILED,
                    })];
            case 11:
                _c.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
export var forgotPassword = sagaFactory('forgotPassword', actions.forgotPassword, callApi.recoverUserAccount, 'recoverUserAccount');
export var updatePassword = sagaFactory('updatePassword', actions.updatePassword, callApi.resetUserPassword, 'resetUserPassword');
export function logout(_a) {
    var next = _a.next;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                StandingStore.removeItem('accessToken');
                StandingStore.removeItem('idToken');
                StandingStore.removeItem('refreshToken');
                StandingStore.removeItem('hubID');
                StandingStore.removeItem('startDateRange');
                StandingStore.removeItem('endDateRange');
                callApi.removePrivateLink();
                next(true);
                return [4 /*yield*/, put({
                        type: actions.logout.type.SUCCESS,
                    })];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export function getUser() {
    var isAdmin, req, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(selectors.getIsAdmin)];
            case 1:
                isAdmin = _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 10, , 12]);
                return [4 /*yield*/, call(callApi.getUser)];
            case 3:
                req = _a.sent();
                if (!req.data.user) return [3 /*break*/, 7];
                return [4 /*yield*/, put({
                        type: actions.getUser.type.SUCCESS,
                        payload: req.data.user,
                    })];
            case 4:
                _a.sent();
                if (!!isAdmin) return [3 /*break*/, 6];
                return [4 /*yield*/, put({
                        type: actions.getPaymentMethods.type.REQUEST,
                    })];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 9];
            case 7: return [4 /*yield*/, put({
                    type: actions.getUser.type.FAILED,
                })];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [3 /*break*/, 12];
            case 10:
                err_2 = _a.sent();
                console.error('getUser', err_2);
                return [4 /*yield*/, put({
                        type: actions.getUser.type.FAILED,
                    })];
            case 11:
                _a.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
export var subscribeEmailOnNotifications = sagaFactory('subscribeEmailOnNotifications', actions.subscribeEmailOnNotifications, callApi.createAreaDemand, 'createAreaDemand');
export var getPaymentMethods = sagaFactory('getPaymentMethods', actions.getPaymentMethods, callApi.getPaymentMethods, 'paymentMethods');
export function updateUser(_a) {
    var res, err_3, message;
    var _b, _c;
    var payload = _a.payload, next = _a.next;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 5, , 7]);
                return [4 /*yield*/, call(callApi.updateUser, payload)];
            case 1:
                res = _d.sent();
                if (!((_b = res.data) === null || _b === void 0 ? void 0 : _b.updateUser)) return [3 /*break*/, 3];
                return [4 /*yield*/, put({
                        type: actions.updateUser.type.SUCCESS,
                        payload: payload,
                    })];
            case 2:
                _d.sent();
                if (next) {
                    next(true);
                }
                return [3 /*break*/, 4];
            case 3: throw new Error(((_c = res.error) === null || _c === void 0 ? void 0 : _c.message) || (res.errors && res.errors[0].message));
            case 4: return [3 /*break*/, 7];
            case 5:
                err_3 = _d.sent();
                message = err_3.message;
                console.error('updateUser', err_3);
                if (next) {
                    next(false, message);
                }
                return [4 /*yield*/, put({
                        type: actions.updateUser.type.FAILED,
                    })];
            case 6:
                _d.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
export function myAccountUpdatePassword(_a) {
    var res, err_4, message;
    var _b, _c;
    var payload = _a.payload, next = _a.next;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 5, , 7]);
                return [4 /*yield*/, call(callApi.updatePassword, payload)];
            case 1:
                res = _d.sent();
                if (!((_b = res.data) === null || _b === void 0 ? void 0 : _b.updatePassword)) return [3 /*break*/, 3];
                return [4 /*yield*/, put({
                        type: actions.myAccountUpdatePassword.type.SUCCESS,
                        payload: payload,
                    })];
            case 2:
                _d.sent();
                if (next) {
                    next(true);
                }
                return [3 /*break*/, 4];
            case 3: throw new Error(((_c = res.error) === null || _c === void 0 ? void 0 : _c.message) || (res.errors && res.errors[0].message));
            case 4: return [3 /*break*/, 7];
            case 5:
                err_4 = _d.sent();
                message = err_4.message;
                console.error('myAccountUpdatePassword', err_4);
                if (next) {
                    next(false, message);
                }
                return [4 /*yield*/, put({
                        type: actions.myAccountUpdatePassword.type.FAILED,
                    })];
            case 6:
                _d.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
export var checkEmail = sagaFactory('checkEmail', actions.checkEmail, callApi.checkEmail, 'checkEmail');
export var getUserById = sagaFactory('getUserById', actions.getUserById, callApi.getUserById, 'userById');
export var getConsolidatedUserById = sagaFactory('getConsolidatedUserById', actions.getConsolidatedUserById, callApi.getConsolidatedUserById, 'userById');
export var getUserRecentTrips = sagaFactory('getUserRecentTrips', actions.getUserRecentTrips, callApi.getUserRecentTrips, 'getUserRecentTrips');
function userSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(actions.login.type.REQUEST, login)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.signUp.type.REQUEST, signUp)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.refresh.type.REQUEST, refresh)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.forgotPassword.type.REQUEST, forgotPassword)];
            case 4:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.updatePassword.type.REQUEST, updatePassword)];
            case 5:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.logout.type.REQUEST, logout)];
            case 6:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getUser.type.REQUEST, getUser)];
            case 7:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.subscribeEmailOnNotifications.type.REQUEST, subscribeEmailOnNotifications)];
            case 8:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getPaymentMethods.type.REQUEST, getPaymentMethods)];
            case 9:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.updateUser.type.REQUEST, updateUser)];
            case 10:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.myAccountUpdatePassword.type.REQUEST, myAccountUpdatePassword)];
            case 11:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.checkEmail.type.REQUEST, checkEmail)];
            case 12:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getUserById.type.REQUEST, getUserById)];
            case 13:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getConsolidatedUserById.type.REQUEST, getConsolidatedUserById)];
            case 14:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getUserRecentTrips.type.REQUEST, getUserRecentTrips)];
            case 15:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default userSaga;
//# sourceMappingURL=user.js.map